import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { secondary } from '../../../theme/colors';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import AppointmentsProgressBar from './components/appointmentsProgressChart';
import CRMCalendar from '../calendar/crmCalendar';
import LeadsCatalog from './components/leadsCatalog';
import ServiceDueDetails from './components/serviceDueDetails';
import ServiceRemindersBarChart from './components/serviceRemindersBarChart';
import { StartSlotsDate } from './components/slotsSelector';
import UpcomingSlotsBarChart from './components/upcomingSlotsBarChart';
import { CrossSellFilters, ServiceDueFilters } from './services/entity';
export default function CRMDashboard() {
    var _getLocalStorageItem, _branches$;
    var branches = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.Branches;
    var dashboardFields = [{
            type: FormItemTypes.Typography,
            name: 'Title',
            columnSize: 10,
            children: 'CRM Dashboard',
            fontSize: 'xxl',
            fontWeight: 'strong'
        }, {
            type: FormItemTypes.SearchSelect,
            name: 'Branch',
            columnSize: 2,
            options: branches,
            displayExpr: 'OrganizationName',
            valueExpr: 'OrganizationId',
            value: (_branches$ = branches[0]) === null || _branches$ === void 0 ? void 0 : _branches$.OrganizationId,
            disableClearable: true
        }, {
            type: FormItemTypes.Custom,
            name: '',
            columnSize: 4,
            element: ServiceRemindersBarChart
        }, {
            type: FormItemTypes.Custom,
            name: '',
            columnSize: 4,
            element: UpcomingSlotsBarChart
        }, {
            type: FormItemTypes.Custom,
            name: '',
            columnSize: 4,
            element: AppointmentsProgressBar,
            containerProps: {
                display: 'flex',
                direction: 'column'
            }
        }, {
            type: FormItemTypes.Tabs,
            name: 'LeadsType',
            value: null,
            columnSize: 6,
            valueExpr: 'id',
            displayExpr: 'label',
            stackContainerProps: {
                border: '1px solid ' + secondary[200],
                borderRadius: 2,
                px: 2,
                py: 1
            },
            tabs: [{
                    id: 'ServiceDue',
                    label: 'Service due',
                    elements: [{
                            type: FormItemTypes.Custom,
                            name: '',
                            columnSize: true
                        }, {
                            type: FormItemTypes.SingleSelect,
                            name: 'ServiceDueFilter',
                            options: ServiceDueFilters,
                            displayExpr: 'Name',
                            valueExpr: 'Name',
                            placeholder: 'All'
                        }, {
                            type: FormItemTypes.Custom,
                            name: 'ServiceDue',
                            columnSize: 12,
                            element: LeadsCatalog,
                            setFormState: function (state, val) { return ({
                                PagingRequest: val ? {
                                    FromDate: StartSlotsDate.toISOString(),
                                    ToDate: StartSlotsDate.add(Number(val), 'days').toISOString()
                                } : undefined
                            }); }
                        }]
                }, {
                    id: 'CrossSell',
                    label: 'Cross sell',
                    elements: [{
                            type: FormItemTypes.Custom,
                            name: '',
                            columnSize: true
                        }, {
                            type: FormItemTypes.SingleSelect,
                            name: 'CrossSellFilter',
                            options: CrossSellFilters,
                            displayExpr: 'Name',
                            valueExpr: 'Name',
                            placeholder: 'All'
                        }, {
                            type: FormItemTypes.Custom,
                            name: 'CrossSell',
                            columnSize: 12,
                            element: LeadsCatalog
                        }]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: 'OverdueType',
            value: null,
            columnSize: 6,
            valueExpr: 'id',
            displayExpr: 'label',
            stackContainerProps: {
                border: '1px solid ' + secondary[200],
                borderRadius: 2,
                px: 2,
                py: 1
            },
            tabs: [{
                    id: 'OverdueService',
                    label: 'Overdue service',
                    elements: [{
                            type: FormItemTypes.Custom,
                            name: '',
                            columnSize: true
                        }, {
                            type: FormItemTypes.SingleSelect,
                            name: 'OverdueServiceFilter',
                            options: ServiceDueFilters,
                            displayExpr: 'Name',
                            valueExpr: 'Name',
                            placeholder: 'All'
                        }, {
                            type: FormItemTypes.Custom,
                            name: 'OverdueService',
                            columnSize: 12,
                            element: LeadsCatalog,
                            setFormState: function (state, val) { return ({
                                PagingRequest: val ? {
                                    FromDate: StartSlotsDate.subtract(Number(val), 'days').toISOString(),
                                    ToDate: StartSlotsDate.toISOString()
                                } : undefined
                            }); }
                        }]
                }, {
                    id: 'OverdueCross',
                    label: 'Overdue cross sell',
                    elements: [{
                            type: FormItemTypes.Custom,
                            name: '',
                            columnSize: true
                        }, {
                            type: FormItemTypes.SingleSelect,
                            name: 'OverdueCrossFilter',
                            options: CrossSellFilters,
                            displayExpr: 'Name',
                            valueExpr: 'Name',
                            placeholder: 'All'
                        }, {
                            type: FormItemTypes.Custom,
                            name: 'OverdueCross',
                            columnSize: 12,
                            element: LeadsCatalog
                        }]
                }]
        }, {
            type: FormItemTypes.Custom,
            name: 'ServiceDueDetails',
            columnSize: 12,
            element: ServiceDueDetails,
            setFormState: function (state, value) { return ({
                PagingRequest: value
            }); }
        }];
    var calendarFields = [{
            type: FormItemTypes.Custom,
            name: 'AppointmentsCalendar',
            columnSize: 12,
            element: function () { /*#__PURE__*/ return React.createElement(CRMCalendar, null); }
        }];
    var analyticsFields = [{
            type: FormItemTypes.Custom,
            name: 'AnalyticsIframe',
            columnSize: 12,
            containerProps: {
                height: 'calc(100svh - 160px)'
            },
            element: function () { /*#__PURE__*/ return React.createElement("iframe", {
                src: "https://app.powerbi.com/view?r=eyJrIjoiMzQ3ODZmNWEtOTA0OC00ZTY2LTk1MDEtYmE3NjgwZTBiMDcwIiwidCI6IjY2ZjY3OTA5LTZjNWYtNDU2OS1iMzZhLTJiOWQ0YzNlNGFhMCIsImMiOjEwfQ%3D%3D",
                width: "100%",
                height: "100%",
                style: {
                    border: 'none'
                }
            }); }
        }];
    var formData = [{
            type: FormItemTypes.Tabs,
            name: 'Tabs',
            columnSize: 12,
            valueExpr: 'id',
            displayExpr: 'Name',
            tabs: [{
                    id: 'dashboard',
                    Name: 'Dashboard',
                    elements: dashboardFields
                }, {
                    id: 'calendar',
                    Name: 'Calendar',
                    elements: calendarFields
                }, {
                    id: 'analytics',
                    Name: 'Analytics',
                    elements: analyticsFields
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "edit",
        formData: formData,
        formProps: {
            px: 2,
            bgcolor: 'white',
            flexGrow: 1,
            height: '100%'
        }
    });
}
